module.exports = __webpack_public_path__ + "static/media/user-friends.54e05e99.svg";